import { render } from "./SuggestedSystemAnalysisPage.vue?vue&type=template&id=77826430&scoped=true&ts=true"
import script from "./SuggestedSystemAnalysisPage.vue?vue&type=script&lang=ts"
export * from "./SuggestedSystemAnalysisPage.vue?vue&type=script&lang=ts"

import "./SuggestedSystemAnalysisPage.vue?vue&type=style&index=0&id=77826430&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77826430"]])

export default __exports__